module.exports = __webpack_public_path__ + "static/img/sjxj.352aaba6.png";